import React, { Fragment, useEffect, useState } from "react";
import * as ReactDOM from "react-dom";
import { useHistory } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import img1 from "styles/common/img/common/picon1.png";
import img2 from "styles/common/img/common/picon2.png";
import img3 from "styles/common/img/common/picon3.png";

const confirmRoot = document.createElement("div");
const body = document.querySelector("body");
body.appendChild(confirmRoot);

const ModalPopup = ({
    giveAnswer,
    onMount,
    type,
    title,
    msg,
    buttonInfo,
    backdrop,
    bigSize,
    autoWidth,
    leftAlign,
    iconType = "1",
}) => {
    const iconImg = iconType === "1" ? img1 : iconType === "2" ? img2 : img3;
    const modalClassName =
        `${bigSize ? "big" : ""} ${autoWidth ? "auto-width" : ""} ${leftAlign ? "left-align" : ""}`.trim();

    useEffect(() => {
        setTimeout(() => onMount && onMount(), 0);
    }, [onMount]);

    return (
        <>
            {type === "ALERT" ? (
                <Modal isOpen={true} className={`popopWrap2 ${modalClassName}`}>
                    <div className="pop_icon">
                        <img src={iconImg} alt="상단 아이콘 이미지" />
                    </div>
                    <div className="pop_txt3" dangerouslySetInnerHTML={{ __html: msg }}></div>
                    <div className="pop_btn2 clear">
                        <button
                            type="button"
                            className="new2btn newbtn__txt newbtn__one"
                            onClick={() => giveAnswer(true)}
                        >
                            확인
                        </button>
                    </div>
                </Modal>
            ) : type === "ALERT_TITLE" ? (
                <Modal isOpen={true} className={`popopWrap2 ${modalClassName}`}>
                    <div className="pop_icon">
                        <img src={iconImg} alt="상단 아이콘 이미지" />
                    </div>
                    {title && <div className="pop_tit">{title}</div>}
                    <div className="pop_txt3" dangerouslySetInnerHTML={{ __html: msg }}></div>
                    <div className="pop_btn2 clear">
                        <button
                            type="button"
                            className="new2btn newbtn__txt newbtn__one"
                            onClick={() => giveAnswer(true)}
                        >
                            확인
                        </button>
                    </div>
                </Modal>
            ) : type === "CONFIRM" ? (
                // 2022-05-26 모달 백그라운드 옵션 추가
                <Modal isOpen={true} backdrop={backdrop ? true : false} className={`popopWrap2 ${modalClassName}`}>
                    <div className="pop_icon">
                        <img src={iconImg} alt="상단 아이콘 이미지" />
                    </div>
                    {title && <div className="pop_tit">{title}</div>}
                    <div className="pop_txt" dangerouslySetInnerHTML={{ __html: msg }}></div>
                    <div className="pop_btn2 clear">
                        <button type="button" className="newbtn newbtn__txt" onClick={() => giveAnswer(false)}>
                            취소
                        </button>
                        <button type="button" className="new2btn newbtn__txt" onClick={() => giveAnswer(true)}>
                            확인
                        </button>
                    </div>
                </Modal>
            ) : type === "CUSTOM" ? (
                <Modal isOpen={true} className={`popopWrap2 ${modalClassName}`}>
                    <div className="pop_icon">
                        <img src={iconImg} alt="상단 아이콘 이미지" />
                    </div>
                    {title && <div className="pop_tit_custom">{title}</div>}
                    <div className="pop_txt" dangerouslySetInnerHTML={{ __html: msg }}></div>
                    <div className="pop_btn2 clear">
                        <button
                            type="button"
                            className="newbtn newbtn__txt"
                            onClick={() => giveAnswer(buttonInfo[0].value)}
                        >
                            {buttonInfo[0].title}
                        </button>
                        <button
                            type="button"
                            className="new2btn newbtn__txt"
                            onClick={() => giveAnswer(buttonInfo[1].value)}
                        >
                            {buttonInfo[1].title}
                        </button>
                    </div>
                </Modal>
            ) : type === "CUSTOM_1" ? (
                <Modal isOpen={true} className={`popopWrap2 ${modalClassName} custom_1`}>
                    <div className="pop_icon">
                        <img src={iconImg} alt="상단 아이콘 이미지" />
                    </div>
                    {title && <div className="pop_tit">{title}</div>}
                    <div className="pop_txt" dangerouslySetInnerHTML={{ __html: msg }}></div>
                    <div className="pop_btn2 clear">
                        <button
                            type="button"
                            className="newbtn newbtn__txt"
                            onClick={() => giveAnswer(buttonInfo[0].value)}
                        >
                            {buttonInfo[0].title}
                        </button>
                        <button
                            type="button"
                            className="new2btn newbtn__txt"
                            onClick={() => giveAnswer(buttonInfo[1].value)}
                        >
                            {buttonInfo[1].title}
                        </button>
                    </div>
                </Modal>
            ) : type === "CUSTOM_2" ? (
                <Modal isOpen={true} className={`popopWrap3 ${modalClassName}`}>
                    <div className="pop_icon">
                        <img src={iconImg} alt="상단 아이콘 이미지" />
                    </div>
                    {title && <div className="pop_title_custom2">{title}</div>}
                    <div className="pop_txt4" dangerouslySetInnerHTML={{ __html: msg }}></div>
                    <div className="pop_btn2 clear">
                        <button
                            type="button"
                            className="new2btn newbtn__txt newbtn__one"
                            onClick={() => giveAnswer(true)}
                        >
                            확인
                        </button>
                    </div>
                </Modal>
            ) : (
                ""
            )}
        </>
    );
};

function AlertConfirmPopup(props) {
    return new Promise((resolve) => {
        const giveAnswer = (answer) => {
            ReactDOM.unmountComponentAtNode(confirmRoot);
            resolve(answer);
        };

        const handleModalMount = () => {
            if (document.querySelector(".modal")?.parentNode) {
                if (document.querySelector(".modal")?.parentNode?.parentNode) {
                    const modalParentNode = document.querySelector(".modal").parentNode.parentNode;
                    modalParentNode.style.zIndex = "initial";
                }
            }
        };

        ReactDOM.render(<ModalPopup giveAnswer={giveAnswer} onMount={handleModalMount} {...props} />, confirmRoot);
    });
}

export default AlertConfirmPopup;
